__turbopack_context__.v({
  "className": "montserrat_8d7b7489-module__cVypbW__className",
  "variable": "montserrat_8d7b7489-module__cVypbW__variable",
});
